module.exports = __webpack_public_path__ + "media/p_bppair_win.5f2e7c91.mp3";